export default function styles(theme){
    return {
        card: {
            display: 'flex',
            alignItems: 'center',
            gap: '20px',
            minWidth: '300px',
            backgroundColor: theme.palette.primary.main,
            transition: '0.3s all ease',
            border: '1px solid rgba(121, 131, 150, 0.15)',
            padding: "1rem",
            borderRadius: "20px",
            scrollSnapAlign: 'center',
            [theme.breakpoints.down("sm")]: {
                padding: "1rem",
                display: 'block',
                gap: '0px',
            },
            "&:hover":{
                border: '1px solid rgba(121, 131, 150, 0.5)',
                // backgroundColor: theme.palette.primary.main,
            },
        },
        cardImg:{
            width:'100%',
            maxWidth: '200px',
            borderRadius: '8px',
            border: '1px solid rgba(121, 131, 150, 0.15)',
            [theme.breakpoints.down("sm")]: {
                maxWidth: '100%',
            },
        },
        cardTitle:{
            fontSize: '1.2rem',
            padding: '10px 0px',
            fontWeight: '600',
            width:'100%',
            color: theme.palette.text.primary,
        },
        cardDescription:{
            width: '100%',
            color: theme.palette.text.tertiary,
            fontSize: '0.8rem',
            marginBottom: '15px',
        },
        cardButton:{
            width:'100% !important',
        }
    };
}